define('commons/v-slider',['jquery'], function($) {

    // Consider only the first child of the container
    var VSlider = function(containerSelector, options) {
        // Configuration settings
        this.settings = {

        };
        $.extend(this.settings, options);

        this.$container = $(containerSelector).first().addClass("v-slider");
        var position = this.$container.css("position");
        if (position != "relative" && position != "absolute" && position != "fixed") {
            this.$container.css("position", "relative");
        }
        this.$content = this.$container.children().first().css("position", "relative");

        // Prepare arrows
        $.each([{
            pos: "top",
            icon: "icon-chevron-up",
            action: "prepend"
        }, {
            pos: "bottom",
            icon: "icon-chevron-down",
            action: "append"
        }], $.proxy(function(index, a) {
            var arrow = $("<div style='display: none' class='v-slider-arrow v-slider-arrow-" + a.pos + " " + a.icon + "'></div>");
            arrow.bind("click", {
                pos: a.pos
            }, $.proxy(this.onArrowClick, this));
            this.$container[a.action](arrow);
            this["arrow" + a.pos.charAt(0).toUpperCase() + a.pos.slice(1)] = arrow;
        }, this));

        this.$win = $(window);
        this.$win.resize($.proxy(this.onResize, this));
        this.$win.bind("v-slider-select", $.proxy(this.onSelect, this));

        // Defining vars
        this.containerHeight = 0;
        this.contentHeight = 0;
        this.offsetTop = 0;

        this.onResize();
    };

    VSlider.prototype.isOnTop = function() {
        return this.offsetTop === 0;
    };

    VSlider.prototype.isOnBottom = function() {
        return this.containerHeight >= this.contentHeight + this.offsetTop;
    };

    VSlider.prototype.onSelect = function(event, item) {
        var $item = $(item);
        var pos = $item.offset().top - this.$content.offset().top;
        var height = $item.outerHeight(false);
        var delta = this.arrowTop.outerHeight(false) - this.offsetTop - pos;
        if (!this.isOnTop() && delta > 0) {
            this.onArrowClick({
                data: {
                    pos: "top",
                    delta: height - delta
                }
            });
        } else {
            delta = this.offsetTop + pos + height - (this.containerHeight - this.arrowBottom.outerHeight(false));
            if (!this.isOnBottom() && delta > 0) {
                this.onArrowClick({
                    data: {
                        pos: "bottom",
                        delta: height - delta
                    }
                });
            }
        }
    };

    VSlider.prototype.onArrowClick = function(event) {
        var dist = this.containerHeight - this.arrowTop.outerHeight(false) - this.arrowBottom.outerHeight(false) -
                (event.data.delta ? event.data.delta : 0);
        var nextTop = event.data.pos == "top" ? Math.min(0, this.offsetTop + dist) : Math.max(this.containerHeight - this.contentHeight,
                this.offsetTop - dist);
        this.offsetTop = nextTop;
        this.$content.animate({
            top: nextTop
        }, 800);
        this.renderArrow(true);
    };

    VSlider.prototype.onResize = function() {
        this.containerHeight = this.$container.height();
        this.contentHeight = this.$content.outerHeight(true);
        var enable = this.containerHeight < this.contentHeight;
        if (!enable && !this.isOnTop()) {
            this.offsetTop = 0;
            this.$content.css("top", 0);
        } else if (enable && this.isOnBottom()) {
            this.offsetTop = -(this.contentHeight - this.containerHeight);
            this.$content.css("top", this.offsetTop);
        }
        this.renderArrow(enable);
    };

    VSlider.prototype.renderArrow = function(enable) {
        this.arrowTop["fade" + (enable && !this.isOnTop() ? "In" : "Out")]();
        this.arrowBottom["fade" + (enable && !this.isOnBottom() ? "In" : "Out")]();
    };

    return VSlider;
});
